
const ShimmerRestaurant = () => {
  return (
    <div className="menu p-5 max-w-5xl m-auto">
      <h1 className="text-4xl font-bold h-10 rounded-md bg-gray-300" ></h1>
      <div className="bg-gray-300  w-full p-30 mt-3 rounded-md">
      </div>
      <h2 className="p-5 h-10 my-3 text-2xl font-medium bg-gray-300"></h2>
      <ul>
      <hr className= "text-gray-400" />
        <div className="flex my-5 gap-4">
          <div className="left w-3/4">
          <h1 className="text-4xl font-bold h-10 rounded-md bg-gray-300" ></h1>
          <h1 className="text-4xl font-bold h-10 rounded-md bg-gray-300 mt-2" ></h1>
          <p className="mt-2 font-medium text-sm bg-gray-300 h-20 w-full" ></p>
          </div>
          <div className="rounded-md w-90 h-44 bg-gray-300 "  alt=""></div>
        </div>
        <hr className= "text-gray-400" />
        <hr className= "text-gray-400" />
        <div className="flex my-5 gap-4">
          <div className="left w-3/4">
          <h1 className="text-4xl font-bold h-10 rounded-md bg-gray-300" ></h1>
          <h1 className="text-4xl font-bold h-10 rounded-md bg-gray-300 mt-2" ></h1>
          <p className="mt-2 font-medium text-sm bg-gray-300 h-20 w-full" ></p>
          </div>
          <div className="rounded-md w-90 h-44 bg-gray-300 "  alt=""></div>
        </div>
        <hr className= "text-gray-400" />
        <hr className= "text-gray-400" />
        <div className="flex my-5 gap-4">
          <div className="left w-3/4">
          <h1 className="text-4xl font-bold h-10 rounded-md bg-gray-300" ></h1>
          <h1 className="text-4xl font-bold h-10 rounded-md bg-gray-300 mt-2" ></h1>
          <p className="mt-2 font-medium text-sm bg-gray-300 h-20 w-full" ></p>
          </div>
          <div className="rounded-md w-90 h-44 bg-gray-300 "  alt=""></div>
        </div>
        <hr className= "text-gray-400" />
      </ul>
    </div>
  )
}

export default ShimmerRestaurant
